import { useMemo } from "react";

export const useUniqueDOMId = () =>
  useMemo(() => `j_${Math.round(Math.random() * 1e10)}`, []);
